module.exports = " <input type=text v-model=slug class=\"form-control w-full mono\" placeholder=\"{{ translate('cp.new').toLowerCase() }}-{{ contentType.toLowerCase() }}\"/> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/MetaFields/Slug.vue
// module id = 303
// module chunks = 0